<app-vault-module-shell
  moduleLabel="Carga de Documentos"
  [accessDenied]="accessDenied()"
  [loadError]="loadError()"
  [loadErrorTitle]="loadErrorTitle()"
>
<section class="ingest-projects">
  <app-page-header
    title="Expedientes de Ingesta"
    subtitle="Gestiona expedientes, recarga el listado o abre carga por lote."
    icon="FolderOpen"
    [actions]="headerActions()"
    (actionClick)="onHeaderAction($event)"
    />

  @if (tableStore.loading()) {
    <div class="loading-container">
      <lib-empty message="Cargando expedientes" description="Espere por favor..." />
    </div>
  }
  @if (info()) {
    <app-vault-page-alert
      type="info"
      title="Aviso"
      [message]="info()"
      (closed)="info.set(null)"
    />
  }
  @if (error()) {
    <app-vault-page-alert
      type="error"
      title="Error"
      [message]="error()"
      (closed)="error.set(null)"
    />
  }

  @if (creating()) {
    <fieldset #createPanel class="ingest-projects__fieldset ingest-projects__edit-panel">
      <legend>Nuevo expediente</legend>
      <div class="ingest-projects__form-row">
      <app-grid-form preset="responsive" wrapperClass="ingest-projects__form-grid">
        <app-grid-form-item [span]="2" class="ingest-field">
          <app-field-label
            label="Nombre"
            [required]="true"
            [tooltip]="projectNameTooltip"
            />
          <lib-input
            label=""
            [externalLabel]="true"
            [maxLength]="projectNameMaxLength"
            placeholder="Nombre corto de carpeta"
            [value]="newProject.name"
            (valueChange)="onNewProjectField('name', $event)"
            />
          <app-vault-form-validation-alert [message]="newProjectNameError()" />
          <div class="ingest-projects__field-footer">
            <span
              class="ingest-projects__field-count"
              [class.ingest-projects__field-count--limit]="newProject.name.length >= projectNameMaxLength"
              >
              {{ newProject.name.length }}/{{ projectNameMaxLength }}
            </span>
          </div>
        </app-grid-form-item>
        <app-grid-form-item [span]="2" class="ingest-field">
          <app-field-label
            label="Descripción"
            [tooltip]="'Texto descriptivo del expediente. Máximo ' + projectDescriptionMaxLength + ' caracteres.'"
            />
          <lib-input
            label=""
            [maxLength]="projectDescriptionMaxLength"
            placeholder="Opcional, hasta 100 caracteres"
            [value]="newProject.description"
            (valueChange)="onNewProjectField('description', $event)"
          />
        </app-grid-form-item>
        <app-grid-form-item [span]="2" class="ingest-field">
          <app-field-label
            label="Carpeta (opcional)"
            tooltip="Ruta base de almacenamiento. Si se deja vacía, se usa el nombre del expediente."
            />
          <lib-input
            label=""
            placeholder="Si vacío, usa el nombre"
            [value]="newProject.folder_path"
            (valueChange)="onNewProjectField('folder_path', $event)"
            />
        </app-grid-form-item>
        <app-grid-form-item [span]="2" class="ingest-field ingest-projects__checkbox-field">
          <app-field-label
            label="Activo"
            tooltip="Indica si el expediente queda habilitado para ingesta y listados."
          />
          <lib-checkbox
            label=""
            [checked]="newProject.is_active"
            (checkedChange)="onNewProjectField('is_active', $event)"
          />
        </app-grid-form-item>
      </app-grid-form>
      <div class="ingest-projects__edit-actions">
        <lib-button
          variant="primary"
          type="button"
          prefixIcon="Plus"
          [disabled]="tableStore.loading()"
          (clicked)="createProject()"
        >
          Crear expediente
        </lib-button>
        <lib-button variant="secondary" type="button" (clicked)="closeCreateForm()">
          Cancelar
        </lib-button>
      </div>
      </div>
    </fieldset>
  }

  @if (editingId !== null) {
    <fieldset
      #editPanel
      class="ingest-projects__fieldset ingest-projects__edit-panel"
    >
      <legend>Editar expediente</legend>
      <div class="ingest-projects__form-row">
      <app-grid-form preset="responsive" wrapperClass="ingest-projects__form-grid">
        <app-grid-form-item [span]="2" class="ingest-field">
          <app-field-label
            label="Nombre"
            [tooltip]="projectNameTooltip"
            />
          <lib-input
            label=""
            [externalLabel]="true"
            [maxLength]="projectNameMaxLength"
            [value]="editForm.name"
            (valueChange)="onEditProjectField('name', $event)"
          />
          <app-vault-form-validation-alert [message]="editProjectNameError()" />
          <div class="ingest-projects__field-footer">
            <span
              class="ingest-projects__field-count"
              [class.ingest-projects__field-count--limit]="editForm.name.length >= projectNameMaxLength"
              >
              {{ editForm.name.length }}/{{ projectNameMaxLength }}
            </span>
          </div>
        </app-grid-form-item>
        <app-grid-form-item [span]="2" class="ingest-field">
          <app-field-label
            label="Descripción"
            [tooltip]="'Texto descriptivo del expediente. Máximo ' + projectDescriptionMaxLength + ' caracteres.'"
            />
          <lib-input
            label=""
            [maxLength]="projectDescriptionMaxLength"
            [value]="editForm.description"
            (valueChange)="onEditProjectField('description', $event)"
          />
        </app-grid-form-item>
        <app-grid-form-item [span]="2" class="ingest-field">
          <app-field-label
            label="Carpeta"
            tooltip="Ruta de carpeta donde se organiza la documentación del expediente."
            />
          <lib-input
            label=""
            [value]="editForm.folder_path"
            (valueChange)="onEditProjectField('folder_path', $event)"
          />
        </app-grid-form-item>
        <app-grid-form-item [span]="2" class="ingest-field ingest-projects__checkbox-field">
          <app-field-label
            label="Activo"
            tooltip="Indica si el expediente queda habilitado para ingesta y listados."
          />
          <lib-checkbox
            label=""
            [checked]="editForm.is_active"
            (checkedChange)="onEditProjectField('is_active', $event)"
          />
        </app-grid-form-item>
      </app-grid-form>
      <div class="ingest-projects__edit-actions">
        <lib-button variant="primary" type="button" prefixIcon="Save" (clicked)="saveEdit()">
          Guardar
        </lib-button>
        <lib-button variant="secondary" type="button" (clicked)="cancelEdit()">Cancelar</lib-button>
      </div>
      </div>
    </fieldset>
  }

  @if (!tableStore.loading() && tableStore.projects().length > 0) {
    <div class="ingest-projects__table-wrap">
      <lib-search
        placeholder="Buscar en la tabla…"
        [searchTerm]="tableStore.searchTerm()"
        (searchTermChange)="onSearchTermChange($event)"
        [loading]="tableStore.loading()"
        />
      <lib-table
        [config]="tableConfig()"
        [data]="tableStore.projects()"
        [loading]="tableStore.loading()"
        [searchTerm]="tableStore.searchTerm()"
        (searchTermChange)="onSearchTermChange($event)"
        [pageSize]="tableStore.pageSize()"
        [pageSizeOptions]="tablePageSizeOptions"
        (pageChange)="onPageChange($event)"
        [sortColumn]="tableStore.sortColumn()"
        [sortDirection]="tableStore.sortDirection()"
        (sortChange)="onTableSort($event)"
        (action)="onTableAction($event)"
        >
        <ng-template #cellTemplate let-row let-column="column">
          @if (column.key === 'name' || column.key === 'folder_path' || column.key === 'description') {
            <span class="ingest-projects__cell-text" [attr.title]="$any(row)[column.key] || ''">
              {{ $any(row)[column.key] || '—' }}
            </span>
          } @else if (column.key === 'activeLabel') {
            <lib-badge
              [text]="row.activeLabel"
              [variant]="row.is_active ? 'success' : 'neutral'"
              size="small"
              />
          }
        </ng-template>
      </lib-table>
    </div>
  }

  @if (!tableStore.loading() && tableStore.projects().length === 0 && editingId === null && !creating()) {
    <lib-empty
      icon="FolderOpen"
      message="No hay expedientes activos"
      [description]="emptyListHint(creating())"
    />
    <div class="vault-empty-cta">
      <lib-button variant="secondary" type="button" prefixIcon="RefreshCcw" (clicked)="loadProjects()">
        Actualizar
      </lib-button>
    </div>
  }
</section>
</app-vault-module-shell>
